import classnames from "classnames"
import React from "react"
import { Row, Col } from "react-bootstrap"
import Form from "react-bootstrap/Form"
import Modal from "react-bootstrap/Modal"
import Button from "../../components/Layout/Button"
import styles from "./ArtworkDetailPage.module.css"
import ReCAPTCHA from "react-google-recaptcha"
import { imageResizer } from "../../../services/utils/imageResizer"

export const ArtworkPurchaseModal = ({
  artworkSize,
  modal,
  handleClose,
  onSubmit,
  artworkDetails,
  setForm,
  form,
  error,
  errorMessage,
  success,
  onReCAPTCHAChange,
  recaptchaRef,
}) => {
  const innerRef = React.createRef()

  React.useEffect(() => {
    setTimeout(() => {
      innerRef.current?.focus()
    }, 1)
  }, [modal])

  return (
    <Modal
      show={modal}
      onHide={handleClose}
      className={styles["modal-content"]}>
      <Modal.Header className={styles["modal"]} closeButton />
      <Modal.Body className={styles["modal-body"]} closeButton>
        {success ? (
          <Row>
            <div className="mx-4 px-2 mb-4 w-100 text-center alert">
              Your purchase request has been sent. We'll get back to you soon.
              <br />
              Thank you!
            </div>
          </Row>
        ) : (
          <>
            <div className="mx-4 px-2">
              <h3 className="text-black mb-3 fs-24px">Purchase</h3>
            </div>
            <Row className="mb-3 mx-4 px-2">
              <Col xs={5}>
                <div
                  className={classnames(
                    styles.BigPostal,
                    styles["image-modal"],
                  )}
                  style={{
                    backgroundSize: "contain",
                    backgroundRepeat: "no-repeat",
                    backgroundPosition: "center",
                    backgroundImage: `url(${imageResizer(
                      artworkDetails.image,
                      `AUTO`,
                      200,
                    )})`,
                  }}
                />
              </Col>
              <Col xs={7}>
                <h5 className="mb-0 text-black font-weight-bold fs-16px">
                  {artworkDetails.title}
                </h5>
                <h5 className="text-black font-weight-normal mb-2 font-primary fs-14px">
                  {artworkDetails.artistname}
                </h5>
                <h5 className="text-black font-weight-normal mb-0 font-primary fs-14px">
                  {artworkDetails.gallery.name}
                </h5>
                <h6 className="color-gray-super-light font-weight-normal font-primary fs-13px">
                  {artworkSize}
                </h6>
              </Col>
            </Row>
            <div>
              <Form className="mx-4 px-2" onSubmit={onSubmit}>
                <Form.Group
                  controlId="exampleForm.ControlInput1"
                  className="mb-2">
                  <Form.Label className="text-capitalize text-black fs-12px">
                    Email*
                  </Form.Label>
                  <Form.Control
                    className="input-font-size"
                    type="email"
                    autoFocus
                    ref={innerRef}
                    onChange={(event) => {
                      setForm({ ...form, email: event.target.value })
                    }}
                  />
                </Form.Group>

                <Row>
                  <Form.Group
                    as={Col}
                    controlId="exampleForm.ControlInput1"
                    className="mb-1 pr-2 pl-3">
                    <Form.Label className="text-capitalize text-black fs-12px">
                      First Name*
                    </Form.Label>
                    <Form.Control
                      className="input-font-size"
                      type="name"
                      onChange={(event) => {
                        setForm({ ...form, firstname: event.target.value })
                      }}
                    />
                  </Form.Group>

                  <Form.Group
                    as={Col}
                    controlId="exampleForm.ControlInput1"
                    className="mb-1 pl-2 pr-3">
                    <Form.Label className="text-capitalize text-black fs-12px">
                      Last Name*
                    </Form.Label>
                    <Form.Control
                      className="input-font-size"
                      type="name"
                      onChange={(event) => {
                        setForm({ ...form, lastname: event.target.value })
                      }}
                    />
                  </Form.Group>
                </Row>

                <Form.Group
                  controlId="exampleForm.ControlInput1"
                  className="mb-1">
                  <Form.Label className="text-capitalize text-black fs-12px">
                    Phone
                  </Form.Label>
                  <Form.Control
                    className="input-font-size"
                    type="phone"
                    onChange={(event) => {
                      setForm({ ...form, phone: event.target.value })
                    }}
                  />
                </Form.Group>

                <Row>
                  <Form.Group
                    as={Col}
                    controlId="formGroupShipping1"
                    className="mb-1">
                    <Form.Label className="text-capitalize text-black fs-12px">
                      Shipping info*
                    </Form.Label>
                    <Form.Control
                      className="input-font-size"
                      type="text"
                      placeholder="Street"
                      onChange={(event) => {
                        setForm({
                          ...form,
                          shipping: {
                            ...form.shipping,
                            street: event.target.value,
                          },
                        })
                      }}
                    />
                  </Form.Group>
                </Row>

                <Row>
                  <Form.Group
                    as={Col}
                    controlId="formGroupShipping2"
                    className="mb-1 pr-0">
                    <Form.Control
                      className="input-font-size"
                      type="text"
                      placeholder="City"
                      onChange={(event) => {
                        setForm({
                          ...form,
                          shipping: {
                            ...form.shipping,
                            city: event.target.value,
                          },
                        })
                      }}
                    />
                  </Form.Group>

                  <Form.Group
                    as={Col}
                    controlId="formGroupShipping3"
                    className="mb-1 pr-0">
                    <Form.Control
                      className="input-font-size"
                      type="text"
                      placeholder="State"
                      onChange={(event) => {
                        setForm({
                          ...form,
                          shipping: {
                            ...form.shipping,
                            state: event.target.value,
                          },
                        })
                      }}
                    />
                  </Form.Group>

                  <Form.Group
                    as={Col}
                    controlId="formGroupShipping3"
                    className="mb-1">
                    <Form.Control
                      className="input-font-size"
                      type="text"
                      placeholder="Zip"
                      onChange={(event) => {
                        setForm({
                          ...form,
                          shipping: {
                            ...form.shipping,
                            zip: event.target.value,
                          },
                        })
                      }}
                    />
                  </Form.Group>
                </Row>

                <Row>
                  <Form.Group
                    as={Col}
                    controlId="formGroupShipping4"
                    className="mb-1">
                    <Form.Control
                      className="input-font-size"
                      type="text"
                      placeholder="Country"
                      onChange={(event) => {
                        setForm({
                          ...form,
                          shipping: {
                            ...form.shipping,
                            country: event.target.value,
                          },
                        })
                      }}
                    />
                  </Form.Group>
                </Row>

                <Form.Group
                  controlId="exampleForm.ControlTextarea1"
                  className="mb-1">
                  <Form.Label className="text-capitalize text-black fs-12px">
                    Message
                  </Form.Label>
                  <Form.Control
                    className="input-font-size"
                    as="textarea"
                    rows="3"
                    onChange={(event) => {
                      setForm({ ...form, body: event.target.value })
                    }}
                  />
                </Form.Group>
                <ReCAPTCHA
                  ref={recaptchaRef}
                  size="invisible"
                  sitekey={process.env.NEXT_PUBLIC_RECAPTCHA_SITE_KEY}
                  onChange={onReCAPTCHAChange}
                />
                {error && (
                  <div className="w-100 alert alert-danger">
                    {errorMessage.map((error) => (
                      <div>
                        {error}
                        <br />
                      </div>
                    ))}
                  </div>
                )}
                <hr />
                <div className={styles.enquireButton}>
                  <Button name="SUBMIT" type="submit" />
                </div>
              </Form>
            </div>
          </>
        )}
      </Modal.Body>
    </Modal>
  )
}
